import {Menu} from 'antd'
import React, {Component, useEffect, useCallback, useState} from "react";
import {useSelector} from "react-redux";
import {NavLink, useLocation} from 'react-router-dom';
import menuList from './../../../../config/menuConfig';
import "./index.scss"


export function LayoutMenu() {
    const sidebarCollapsed = useSelector((state) => {
        return state.switcher.sidebarCollapsed
    });
    const location = useLocation();

    const [menuTreeNode, setMenuTreeNode] = useState([])
    const [openKeys, setOpenKeys] = useState([])
    const [rootSubmenuKeys, setRootSubmenuKeys] = useState([])
    const [allKeys, setAllKeys] = useState([])

    const onOpenChange = useCallback((keys) => {
        //新展开的menu
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys)
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
        }
    })

    const getMenuNodes = useCallback((menus, key = '') => {
        // 得到当前请求的路由路径
        const path = location.pathname;
        return menus.map(item => {
            const routeKey = item.path.startsWith('/') ? item.path : `${key}/${item.path}`
            if (item.children && !item.hiddenChild) {
                if (path.includes(routeKey)) {
                    setOpenKeys([...openKeys, routeKey])
                }
                const children = getMenuNodes(item.children, routeKey)
                return getItem(item.title, routeKey, item.icon, children)
            } else {
                if (!item.hide) {
                    return getItem(<NavLink to={item.path}>{item.title}</NavLink>, routeKey, item.icon)
                }
            }
        })
    })

    useEffect(() => {
        const menuTreeNode = getMenuNodes(menuList);
        setRootSubmenuKeys(menuList.filter(item => item.children).map(item => item.path))
        setMenuTreeNode(menuTreeNode)
        setAllKeys(menuList.filter(item => item.children).map(item => item.path))
    }, [])

    return (<div className="sidebar-menu-container">
        <Menu
            selectedKeys={[location.pathname]}
            openKeys={sidebarCollapsed?openKeys:allKeys}
            onOpenChange={(keys) => onOpenChange(keys)}
            mode="inline"
            theme="dark"
            items={menuTreeNode}
        />
    </div>)
}


function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}

export default LayoutMenu